export default "__VITE_ASSET__CZkPvbwU__"